exports = module.exports = require("../../../../node_modules/fast-css-loader/lib/css-base.js")(false);
// imports

// module
exports.push([module.id, ".errata-summary .strips-and-filter {\n  margin-bottom: 8rem; }\n\n.errata-summary .filter {\n  width: auto; }\n\n.errata-summary .body-block {\n  padding: 0;\n  width: 100%; }\n", ""])